module.exports = __webpack_public_path__ + "static/img/wh-106.00e81ff2.png";